export const resolveOptionTooltip = ({
  technicalName,
  isHighlighted,
  highlightedTooltip,
}: {
  technicalName?: string;
  isHighlighted: boolean;
  highlightedTooltip?: string;
}): string | undefined => {
  const parts = [
    technicalName,
    isHighlighted ? highlightedTooltip : undefined,
  ].filter((part): part is string => Boolean(part));

  return parts.length ? parts.join(" · ") : undefined;
};
